<template>
  <div class="login-container">
    <div class="login-form-wrapper">
      <div class="login-header">
        <h1 class="login-title">数据统计系统</h1>
        <p class="login-subtitle">请登录您的账号</p>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        label-position="top"
        class="login-form"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            clearable
            size="large"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            clearable
            size="large"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="large"
            class="login-button"
            :loading="loading"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: ['blur', 'change']
          }
          // {
          //   pattern: /^1[3-9]\d{9}$/,
          //   message: '请输入正确的手机号格式',
          //   trigger: 'blur'
          // }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            message: '密码长度不能少于6个字符',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    };
  },
  computed: {},
  methods: {
    ...mapActions(['login', 'getUserInfo', 'getEnterpriseList']),
    // 登录
    async handleLogin() {
      try {
        this.loading = true;
        await this.$refs.loginForm.validate();
        // 调用vuex的登录action
        await this.login(this.loginForm);

        Promise.all([this.getUserInfo(), this.getEnterpriseList()]).then(() => {
          this.loading = false;
          // 登录成功后跳转到首页
          this.$message.success({
            message: '登录成功',
            duration: 500
          });
          this.$router.push('/');
        });
      } catch (error) {
        this.loading = false;
        // this.$message.error(error.message || '登录失败，请稍后重试');
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* 渐变背景 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  /* 添加背景装饰 */
  position: relative;
  overflow: hidden;
}

/* 背景装饰元素 */
.login-container::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  top: -100px;
  left: -100px;
  animation: float 6s ease-in-out infinite;
}

.login-container::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  bottom: -50px;
  right: -50px;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(20px, 20px);
  }
}

.login-form-wrapper {
  width: 100%;
  max-width: 420px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  padding: 45px;
  /* 添加模糊效果 */
  backdrop-filter: blur(10px);
  /* 过渡效果 */
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

/* 鼠标悬停效果 */
.login-form-wrapper:hover {
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.login-header {
  text-align: center;
  margin-bottom: 35px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  /* 文字阴影 */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  /* 字母间距 */
  letter-spacing: 0.5px;
}

.login-form {
  width: 100%;
}

/* Element UI 表单项调整 */
.login-form /deep/ .el-form-item {
  margin-bottom: 25px;
}

.login-form /deep/ .el-form-item__label {
  font-size: 14px;
  color: #555;
  font-weight: 500;
  margin-bottom: 8px;
}

/* 输入框样式优化 */
.login-form /deep/ .el-input__inner {
  border-radius: 12px;
  /* padding: 12px 16px; */
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  font-size: 15px;
}

.login-form /deep/ .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  outline: none;
}

/* 输入框前缀图标 */
.login-form /deep/ .el-input__prefix {
  color: #999;
}

/* 登录按钮样式 */
.login-button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  letter-spacing: 0.5px;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

.login-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-form-wrapper {
    padding: 35px 25px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 13px;
  }

  .login-form /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  .login-button {
    height: 46px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 15px;
  }

  .login-form-wrapper {
    padding: 30px 20px;
    border-radius: 16px;
  }

  .login-title {
    font-size: 22px;
  }

  .login-button {
    height: 44px;
    font-size: 15px;
  }
}
</style>
